<template>
  <div v-if="isPC" class="message-input">
    <FormPC :payload="forwardPayload" @sendMessage="handleSendForm" />
  </div>
  <div v-else>
    <FormMobile :payload="forwardPayload" @sendMessage="handleSendForm" @showFormPopup="handleShowFormPopup"/>
  </div>
</template>

<script lang="ts">
import vue from '../../../../../../../adapter-vue';
import FormPC from './form-pc.vue';
import FormMobile from './form-mobile.vue';
import { customerServicePayloadType } from '../../../../../../../interface';
import { isPC } from '../../../../../../../utils/env';
const { computed } = vue;

interface Props {
  payload: customerServicePayloadType;
}

export default {
  components: {
    FormPC,
    FormMobile
  },
  props: {
    payload: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['sendMessage','showFormPopup'],
  setup(props: Props, { emit }) {
    const handleSendForm = (data: any) => {
      emit('sendMessage', data);
    };
    const handleShowFormPopup = (data: boolean) => {
      emit('showFormPopup', data);
    }
    const forwardPayload = computed(() => {
      return props.payload;
    });
    return {
      forwardPayload,
      handleSendForm,
      isPC,
      handleShowFormPopup
    };
  },
};
</script>
<style lang="scss">

</style>
